var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.3789C11.8786 22.3789 11.7572 22.3475 11.6485 22.2847C11.5304 22.2166 8.72392 20.5871 5.8772 18.1319C4.18999 16.6767 2.84318 15.2335 1.87427 13.8422C0.620464 12.0419 -0.0100507 10.3103 0.000121129 8.69531C0.0120274 6.81609 0.685104 5.04881 1.89551 3.71897C3.12635 2.36673 4.76894 1.62207 6.5208 1.62207C8.76596 1.62207 10.8187 2.87972 12.0001 4.872C13.1814 2.87977 15.2341 1.62207 17.4793 1.62207C19.1344 1.62207 20.7134 2.29398 21.9258 3.51404C23.2563 4.85292 24.0123 6.7447 23.9999 8.70421C23.9897 10.3164 23.3473 12.0454 22.0908 13.8432C21.1189 15.2337 19.7739 16.6764 18.0933 18.1311C15.257 20.5861 12.4707 22.2155 12.3535 22.2836C12.2442 22.3471 12.1221 22.3789 12 22.3789Z",
    fill: "#EB6E1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.411a5466c9d258b27b71ed9ac666ce8d.svg";
export { ForwardRef as ReactComponent };